import { render } from "./PaginationComponent.vue?vue&type=template&id=a9097978&ts=true"
import script from "./PaginationComponent.vue?vue&type=script&lang=ts"
export * from "./PaginationComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__